module.exports = __webpack_public_path__ + "static/img/zhuanli-2.5b050ebb.png";